module.exports = __webpack_public_path__ + "img/review-claim-reward.0a5e1be6.png";